import { HStack, Tag, TagLabel } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { DEFAULT_HARDCODED_TAGS, POPULAR_SEARCH_TAGS } from './PhotoWidgetMenu.config';

interface SuggestedTagListProps {
  onTagClick: (value: string, shouldSetQueryStr?: boolean) => void;
}

// Overrides the scrollbar styling in HStack component for displaying tags in horizontal list
// prevents ugly native scrollbars on certain browsers when a HID cursor device is connected
// TODO: Move to it's own wrapper component if it has other use cases
const StyledTagList = styled(HStack)`
  ::-webkit-scrollbar {
    height: 6px;
  }
  ::-webkit-scrollbar-thumb {
    background: var(--vg-colors-gray-200);
    border-radius: 10px;
  }
  ::-webkit-scrollbar-track {
    background: transparent;
  }
`;

export const SuggestedTagList = memo(({ onTagClick: onTagSearch }: SuggestedTagListProps) => {
  const tags = useMemo(() => [...POPULAR_SEARCH_TAGS, ...DEFAULT_HARDCODED_TAGS], []);
  const { t } = useTranslation('editor_widget_menu', { useSuspense: false, keyPrefix: 'sideMenu.photosMenu.tags' });

  const onTagClick = (value: string) => () => {
    onTagSearch(value);
  };

  return (
    <StyledTagList overflowX={'auto'} spacing={2} padding={2} paddingX={4} minHeight={12} data-testid='suggested-tags'>
      {/* FIXME: Limit tags to first four temporarily until list can be properly scrollable */}
      {tags.slice(0, 4).map((tag, index) => {
        return (
          <Tag
            key={index}
            as={'button'}
            size={'sm'}
            variant={'suggested-tag'}
            onClick={onTagClick(tag)}
            pointerEvents={'auto'}
          >
            <TagLabel>{t(tag as keyof typeof t)}</TagLabel>
          </Tag>
        );
      })}
    </StyledTagList>
  );
});
SuggestedTagList.displayName = 'SuggestedTagList';
